/**
 * Default pagination configuration for tables.
 */
export const tablePaginationConfig = {
  pageSize: 10,
  pageSizeOptions: [5, 10, 20, 50],
};
